{
  "app": {
    "name": "{gameName}",
    "welcome": "Welcome to {gameName}",
    "about": "About {gameName}"
  },
  "tabs": {
    "home": "Home",
    "golfer": "Golfer",
    "play": "Play",
    "club": "Club",
    "more": "More"
  },
  "topbar": {
    "coins": "{count, plural, one {# Coin} other {# Coins}}",
    "aces": "{count, plural, one {# Ace} other {# Aces}}",
    "wallet": "Wallet",
    "inbox": "Inbox",
    "inbox_unread": "{count, plural, =0 {No new messages} one {# new message} other {# new messages}}",
    "search": "Search",
    "caddie_help": "Caddie help"
  },
  "minibar": {
    "decision_open": "LIVE · Hole {hole} · {position} {toPar} · Decision open",
    "routine_playing": "LIVE · Hole {hole} · {position} {toPar} · Your Routine is playing"
  },
  "notice": {
    "page_unavailable": "This page isn't available",
    "spending_off": "Spending is off. A parent can switch it on.",
    "club_owner_age": "Owning a club is for players aged 18 and over",
    "data_line": "We use anonymous play data to make the game better and fairer — never your name, never your exact age."
  },
  "nav": {
    "tab": {
      "home": "Home",
      "golfer": "Golfer",
      "play": "Play",
      "club": "Club",
      "more": "More"
    },
    "link": {
      "feed": "The Feed",
      "messages": "Messages",
      "wallet": "Wallet",
      "shop": "Shop",
      "settings": "Settings",
      "roles": "Roles"
    },
    "sidebar": {
      "brand": "{gameName}",
      "more_heading": "More"
    },
    "topbar": {
      "wallet": "Wallet",
      "inbox": "Inbox",
      "search": "Search",
      "help": "Caddie help",
      "back_to": "{where}, back",
      "summary_clock": "{weekday} {day} {month} · {time}",
      "summary_clock_short": "{day} {month} · {time}",
      "summary_clock_label": "Game time {weekday} {day} {month}, {time}",
      "summary_week": "Wk {week}/{of}",
      "summary_week_label": "Season week {week} of {of}",
      "summary_handicap": "Hcp {value}",
      "summary_handicap_label": "Handicap {value}",
      "summary_coins_label": "{count} Coins. Open the wallet"
    }
  },
  "home": {
    "today": {
      "title": "Today",
      "coming": "Your golfer's day will be here: training, rounds, results and club news."
    }
  },
  "golfer": {
    "overview": {
      "title": "Golfer",
      "coming": "Your golfer's skills, bag and record will be here."
    }
  },
  "play": {
    "calendar": {
      "title": "Play",
      "coming": "Your golfer's events and their days will be listed here."
    }
  },
  "club": {
    "home": {
      "title": "Club",
      "coming": "Your club's notices, members and competitions will be here."
    }
  },
  "more": {
    "list": {
      "title": "More",
      "social": "Social",
      "money": "Money and items",
      "world": "World",
      "help": "Help"
    }
  },
  "social": {
    "feed": {
      "title": "The Feed",
      "coming": "Posts from players and clubs will be here."
    },
    "messages": {
      "title": "Messages",
      "coming": "Your messages with friends will be here."
    }
  },
  "money": {
    "wallet": {
      "title": "Wallet",
      "coming": "Your Coins and Aces will be shown here."
    },
    "shop": {
      "title": "Shop",
      "coming": "The shop will be here."
    }
  },
  "system": {
    "settings": {
      "title": "Settings",
      "coming": "Your settings for views, sound, units and limits will be here.",
      "account": "Account",
      "privacy": "Privacy and safety",
      "game": "Your game",
      "sign_in_methods_line": "Add another way to sign in",
      "sign_out_line": "Only on this device",
      "consent_line": "Choose what we may count",
      "data_export_line": "A copy of what we keep",
      "account_deletion_line": "30 days to change your mind",
      "holiday_line": "Take a break, lose nothing",
      "views_line": "How the game looks",
      "interests_line": "How things are explained",
      "about_line": "Where the maps come from",
      "more_coming": "More settings are on the way: sound, units and limits."
    },
    "unavailable": {
      "title": "This page isn't available",
      "body": "Choose a tab to carry on."
    }
  },
  "roles": {
    "hub": {
      "title": "Roles",
      "coming": "Side roles, such as coach and club manager, will be listed here.",
      "club_manager_age": "Club manager is for players aged 18 and over"
    }
  },
  "state": {
    "screen": {
      "loading": "Loading",
      "coming_soon": "Coming soon",
      "error_message": "We couldn't load this. Check your connection and try again.",
      "retry": "Try again",
      "get_help": "Get help",
      "reference": "Reference {code}",
      "offline_stamp": "Offline · updated {time}",
      "needs_connection": "Needs a connection"
    }
  },
  "help": {
    "sheet": {
      "title": "Caddie help",
      "body": "Tips for each screen arrive as the screen is built.",
      "close": "Close",
      "back": "Back"
    }
  },
  "guest": {
    "locked": {
      "chat": "Save your progress to chat with other players.",
      "post": "Save your progress to post in The Feed.",
      "message": "Save your progress to send messages.",
      "befriend": "Save your progress to add friends.",
      "trade": "Save your progress to trade.",
      "buy": "Save your progress to buy anything.",
      "prize_entry": "Save your progress to enter competitions with prizes.",
      "link_parent": "Save your progress to link a parent's account."
    }
  },
  "about": {
    "title": "About",
    "back": "Back",
    "intro": "{gameName} is a golf game. Here is where its hole maps and its letters come from.",
    "maps_title": "Where the hole maps come from",
    "maps_body": "The holes are made up for the game. The shape of the ground under them is real. The Environment Agency made maps of it from the air, with lasers (LIDAR).",
    "maps_data": "Data: Environment Agency, LIDAR Composite DTM 1 m.",
    "maps_licence": "Contains public sector information licensed under the Open Government Licence v3.0.",
    "maps_credit": "© Environment Agency copyright and/or database right 2026. All rights reserved.",
    "licence_link": "Read the Open Government Licence",
    "fonts_title": "The letters",
    "fonts_body": "The words in the game use two fonts. Both are free to use in apps under the SIL Open Font License 1.1, and a copy of each licence comes with the game.",
    "font_inter": "Inter, by The Inter Project Authors.",
    "font_barlow": "Barlow Condensed, by The Barlow Project Authors.",
    "icons_title": "The icons",
    "icons_body": "Many of the small pictures on the buttons are Phosphor Icons, used under the MIT licence. The golf icons are drawn for the game."
  },
  "account_deletion": {
    "title": "Delete my account",
    "back": "Back",
    "settings_link": "Delete my account",
    "guest": "You are playing without an account, so there is nothing to delete yet. When you save your progress, you can delete your account here at any time.",
    "what_happens_title": "What happens",
    "what_happens_1": "Your golfer and your account are hidden from other players straight away.",
    "what_happens_2": "You have 30 days to change your mind. Sign in again, or come back here and tap Keep my account.",
    "what_happens_3": "After 30 days, your account and your personal data are deleted for good. Results tables will say \"Deleted golfer\".",
    "delete": "Delete my account",
    "confirm_title": "Are you sure?",
    "confirm_body": "This starts the 30 days. You can still change your mind until {date}.",
    "confirm_yes": "Yes, delete my account",
    "confirm_no": "No, go back",
    "pending": "Your account will be deleted on {date}. That is {days} days from now.",
    "keep": "Keep my account",
    "kept": "Your account is kept. Nothing has changed.",
    "error": "That did not work. Nothing has changed. Please try again."
  },
  "save": {
    "title": "Save your progress",
    "new_player_title": "One more step",
    "new_player_why": "This email has no account yet. Tell us your date of birth to make one.",
    "why": "Your golfer and rounds are kept, on every device you sign in on.",
    "dob_label": "Your date of birth",
    "dob_help": "We ask to keep younger players safe. We never show it to anyone.",
    "day": "Day",
    "month": "Month",
    "year": "Year",
    "home_label": "Where do you live?",
    "home_gb": "England, Scotland or Wales",
    "home_ni": "Northern Ireland",
    "home_ie": "Ireland",
    "home_elsewhere": "Somewhere else",
    "continue": "Continue",
    "not_a_date": "That is not a date we can use. Please check the day, month and year.",
    "no_home": "Please choose where you live.",
    "under_13": "{gameName} needs players to be 13 or older right now. We haven't saved anything.",
    "region": "{gameName} is open in the UK and Ireland for now. We haven't saved anything.",
    "ok": "Back to the game",
    "sign_in_title": "How will you sign in?",
    "google": "Continue with Google",
    "apple": "Continue with Apple",
    "email_link": "Email me a sign-in code",
    "email_title": "Sign in with email",
    "email_label": "Your email address",
    "email_send": "Send the code",
    "bad_email": "That does not look like an email address. Please check it.",
    "email_sent_title": "Check your email",
    "email_sent": "We sent a 6-digit code to {email}.",
    "code_label": "Code",
    "code_submit": "Sign in",
    "code_resend": "Send a new code",
    "code_resent": "We sent a new code. Only the newest code works.",
    "code_short": "Type the 6 numbers from the email.",
    "code_wrong": "That code did not work. Check it is the code from the newest email, or send a new one.",
    "code_too_many": "Too many tries. Please wait a few minutes, then try again.",
    "email_other": "Use a different email",
    "back": "Back",
    "saving": "Signing you in…",
    "done_title": "Saved",
    "done": "Your golfer and rounds are now on your account.",
    "done_new_title": "Signed in",
    "done_new": "Your account is ready.",
    "done_back_title": "Welcome back",
    "done_back": "You're signed in.",
    "done_button": "Done",
    "cancelled": "Sign-in was closed. Nothing has changed.",
    "error": "That did not work. Nothing has changed. Please try again.",
    "admin_account": "This email is an admin account, so it cannot have a golfer. To play, sign in with a different email.",
    "too_soon": "We have sent a few codes just now. Please wait a while, then send a new one.",
    "too_soon_minutes": "Please wait {count, plural, one {# minute} other {# minutes}}, then send a new code.",
    "link_expired": "This link has stopped working. A link works once, and only the newest one works. Please send a new code."
  },
  "consent": {
    "title": "Help us improve {gameName}",
    "body": "May we count how you use the game, such as which screens you open? It never includes your name, your email or your age.",
    "change": "You can change this at any time in Settings, under Privacy choices.",
    "accept": "Yes, that's fine",
    "reject": "No, thanks",
    "now_on": "Now: counting is on.",
    "now_off": "Now: counting is off.",
    "saved": "Saved. Thank you.",
    "settings_link": "Privacy choices",
    "back": "Back"
  },
  "data_export": {
    "settings_link": "Download my data",
    "title": "Download my data",
    "body": "A file with what we keep about your account: your golfer, your rounds and your settings. Only you get it.",
    "button": "Download my data",
    "guest": "You are playing without an account, so there is nothing to download yet. When you save your progress, you can download your data here at any time.",
    "ready": "Your data is ready.",
    "too_soon": "You downloaded your data a short time ago. Please try again later.",
    "error": "That did not work. Please try again.",
    "back": "Back"
  },
  "sign_in_methods": {
    "settings_link": "Ways to sign in",
    "title": "Ways to sign in",
    "body": "Add another way to sign in to this same account. Each one asks you to sign in with it first.",
    "have": "You can sign in with:",
    "none_yet": "Checking how you can sign in…",
    "method_google": "Google",
    "method_apple": "Apple",
    "method_email": "An email code",
    "add_google": "Continue with Google",
    "add_apple": "Continue with Apple",
    "add_email": "Add an email address",
    "email_label": "Email address",
    "send": "Send the link",
    "sent": "We sent a link to that address. Open it to add the address.",
    "linked": "Added. You can now sign in this way too.",
    "taken": "That sign-in already belongs to another account, so we did not join the two. Our support team can look at it for you.",
    "bad_email": "Please check the email address.",
    "cancelled": "Nothing was changed.",
    "error": "That did not work. Please try again.",
    "guest": "Save your progress first. Then you can add more ways to sign in.",
    "save": "Save your progress",
    "back": "Back"
  },
  "world": {
    "map": {
      "title": "World map"
    },
    "atlas": {
      "title": "Course Atlas"
    },
    "credits": {
      "title": "Credits and licences"
    },
    "passport": {
      "title": "Passport"
    }
  },
  "sign_out": {
    "settings_link": "Sign out"
  }
}
